/**
 * The product route's `ItemCardSource` (M1-B7 §5), matching `useBoardSource`'s shape: one
 * source per mounted board, built from the tRPC proxy through the narrow `ItemCardApi` port.
 */
import { useMemo } from 'react';
import { useTRPCClient } from '../../lib/trpc';
import { useBootstrap } from '../shell/bootstrap';
import { createItemCardApi, createTrpcItemCardSource } from './trpc-source';
import type { ItemCardSource } from './types';

export function useItemCardSource(): ItemCardSource | null {
  const client = useTRPCClient();
  const bootstrap = useBootstrap().data?.me ?? null;

  return useMemo(() => {
    if (!bootstrap) return null;
    return createTrpcItemCardSource({
      api: createItemCardApi(client as never),
      me: { id: bootstrap.id, name: bootstrap.name ?? '', photoUrl: null },
    });
  }, [client, bootstrap]);
}
